import { default as Image } from '@react/shared/components/Image';
import { MostSearchedRegionsContentProps } from 'sly/agentsPage/components/AgentsContent/MostSearchedRegions/MostSearchedRegionsContent/MostSearchedRegionsContent.types';
import MostSearchedRegionsContentHeading from 'sly/agentsPage/components/AgentsContent/MostSearchedRegions/MostSearchedRegionsContent/MostSearchedRegionsContentHeading';

export default function MostSearchedRegionsContent({
  image,
  alt,
  title,
  states,
}: MostSearchedRegionsContentProps) {
  return (
    <div
      className='relative h-full w-full rounded-[4px] bg-black'
      data-tp-id='gen-div-dc46942c-a586-4ea6-a201-c23668f79851'
    >
      <div
        className='relative block h-full w-full rounded-sm object-cover pt-[56.25%] opacity-75'
        data-tp-id='gen-div-e9984b4e-fa51-417c-bfee-7bc99f1db000'
      >
        <Image
          layout='raw'
          height={200}
          width={200}
          path={image}
          alt={alt}
          className='absolute top-0 left-0 h-full w-full object-cover'
          data-tp-id='gen-Image-fb75e1bb-5609-4749-bae8-dcd7984d18cc'
        />
      </div>
      <div
        className='absolute top-1/2 left-1/2 w-full -translate-x-1/2 -translate-y-1/2 py-0 px-4 text-center'
        data-tp-id='gen-div-cd921f2e-a4ee-49a4-91d8-de10ecb45def'
      >
        <MostSearchedRegionsContentHeading title={title} />
        <div
          className='text-white'
          data-tp-id='gen-div-fc8f41e5-5b12-426b-a461-da662244ff0f'
        >
          <strong> Includes: </strong>
          {states}
        </div>
      </div>
    </div>
  );
}
